/* assets/es-fallback-translate.js */
(function () {
  "use strict";

  var lang = (document.documentElement.getAttribute("lang") || "").toLowerCase();
  if (lang !== "es" && lang.indexOf("es-") !== 0) return;

  var textMap = {
    "10% DISCOUNT": "10% DESCUENTO",
    "3-step routine": "Rutina de 3 pasos",
    "Add all 3 to cart": "Agregar los 3 al carrito",
    "Add routine to cart": "Agregar rutina al carrito",
    "Add your email, or skip and see your routine now.": "Agrega tu email, o salta y ve tu rutina.",
    "Answer 13 short questions and get your routine in about 2 minutes.": "Responde 13 preguntas y ten tu rutina en 2 minutos.",
    "Answer 9 quick questions and get your routine in about 90 seconds.": "Responde 9 preguntas y ten tu rutina en 90 segundos.",
    "Answer a few quick questions and get your routine.": "Responde unas preguntas y recibe tu rutina.",
    "Answer a few quick questions. Get a routine tailored to your skin.": "Responde unas preguntas. Recibe una rutina para tu piel.",
    "Personalized in minutes.": "Personalizada en minutos.",
    "Building your report...": "Creando tu informe...",
    "Country/Region": "País/Región",
    "Customer Reviews": "Opiniones de clientes",
    "Discover Your Unique": "Descubre tu piel única",
    "Discover Your  Unique": "Descubre tu piel única",
    "Your Skin,": "Tu Piel,",
    "Perfected.": "Perfeccionada.",
    "Skincare, elevated.": "Cuidado de la piel, a otro nivel.",
    "Don't know where to start?": "¿No sabes por dónde empezar?",
    "Email me and show routine": "Enviar email y mostrar rutina",
    "Find your skin type": "Descubre tu tipo de piel",
    "Full routine": "Rutina completa",
    "Get exclusive deals and early access to new products.": "Recibe ofertas exclusivas y acceso anticipado a nuevos productos.",
    "Get your personalized skin routine": "Consigue tu rutina personalizada",
    "Getting your routine...": "Preparando tu rutina...",
    "Join the Club!": "¡Únete al club!",
    "More info": "Más info",
    "Optional extras": "Extras opcionales",
    "Out of stock": "Agotado",
    "Over 241+": "Más de 241",
    "Professional salons trust our products": "Salones profesionales confían en nuestros productos",
    "Retake quiz": "Repetir el cuestionario",
    "Skin Journey": "Ruta de tu piel",
    "Skin quiz": "Cuestionario de piel",
    "Skip and show my routine": "Saltar y mostrar mi rutina",
    "Start quiz": "Empezar cuestionario",
    "Stop guessing. Get a routine built for your skin.": "Deja de adivinar. Ten una rutina para tu piel.",
    "Stories from quiz completers": "Historias de quienes lo hicieron",
    "The science of healthy skin, simplified": "La ciencia de una piel sana, en simple",
    "This quiz is educational only and not medical advice. For severe irritation, please consult a qualified professional.": "Este cuestionario es educativo y no sustituye el consejo médico. Si tienes irritación fuerte, consulta a un profesional.",
    "Try instead:": "Prueba en su lugar:",
    "View all": "Ver todo",
    "View full routine collection": "Ver la colección completa",
    "Want your routine by email?": "¿Quieres tu rutina por email?",
    "Your 3-step routine": "Tu rutina de 3 pasos",
    "Your favorites, backed by results": "Tus favoritos, con resultados reales",
    "Your full routine": "Tu rutina completa",
    "Your skin profile": "Tu tipo de piel"
  };

  /*
   * Product names are brand names and stay in English on every storefront.
   * snippets/product-name.liquid already does this for everything the theme
   * renders; this map is the safety net for names that arrive after render,
   * from app widgets (reviews, wholesale search) and third-party scripts.
   *
   * Keys are the Spanish titles Shopify stores in Translate & Adapt, so unlike
   * the copy above they keep their accents exactly as Shopify emits them.
   * Regenerate alongside the Liquid map: node scripts/sync-product-names.js
   */
  /* product-names:start */
  var productNames = {
    "Balance + Crema": "Balance + Cream",
    "Crema CC Stop The Time FPS 30": "Stop The Time CC Cream SPF 30",
    "Crema Cellu-Lift": "Cellu-Lift Cream",
    "Crema iluminadora FPS 50": "Brightening Cream SPF 50",
    "Crema vitamínica Hydra": "Hydra Vitamin Cream",
    "Cura suiza de desintoxicación": "Detox Swiss Cure",
    "Exfoliante tropical": "Tropical Exfoliator",
    "Jabón de limpieza profunda": "Deep Cleansing Soap",
    "Leche calmante rosa": "Pink Calming Milk",
    "Loción Verde Botánica": "Botanic Green Lotion",
    "Loción corporal calmante y vitalizante": "Calming & Vitalising Body Lotion",
    "Mascarilla calmante reequilibrante": "Rebalancing Calming Mask",
    "Mascarilla facial desintoxicante": "Detox Face Mask",
    "Mini Pack de Peeling Natural": "Natural Peeling Mini Pack",
    "Oxygenius Day FPS 30": "Oxygenius Day SPF 30",
    "Peeling Natural Completo (Mixto/Graso)": "Natural Peeling Complete (Combination / Oily)",
    "Peeling Natural Completo (piel seca)": "Natural Peeling Complete (dry skin)",
    "Peeling detox de hammam": "Detox Hammam Peeling",
    "Set de viaje: Piel mixta y grasa": "Travel Set: Combination & Oily Skin",
    "Set de viaje: Piel seca y deshidratada": "Travel Set: Dry & Normal Skin",
    "Solución de peeling natural": "Natural Peeling Solution",
    "Solución ligera de peeling natural": "Natural Peeling Light Solution",
    "Tratamiento celular Stop The Time": "Stop The Time Cellular Treatment",
    "Tratamiento de masaje facial nocturno": "Face Massage Night Treatment",
    "Vitalislim Roll-On Anticelulítico": "Vitalislim Roll-On Anti-Cellulite"
  };
  /* product-names:end */

  /*
   * Product names also turn up inside longer strings ("Cura suiza de
   * desintoxicación - 250 ml"), so they match as substrings. Longest first, so
   * that a name never gets partly replaced by a shorter one that overlaps it.
   */
  var productNamePattern = (function () {
    var names = Object.keys(productNames).sort(function (a, b) {
      return b.length - a.length;
    });
    if (!names.length) return null;
    var parts = names.map(function (name) {
      return name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&").replace(/\s+/g, "\\s+");
    });
    return new RegExp(parts.join("|"), "g");
  })();

  function restoreProductNames(value) {
    if (!productNamePattern) return value;
    return value.replace(productNamePattern, function (match) {
      return productNames[normalizeText(match)] || match;
    });
  }

  /* Text inside these never reaches the reader, and rewriting it corrupts data. */
  var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, TEMPLATE: 1 };

  function normalizeText(value) {
    return String(value || "").replace(/\s+/g, " ").trim();
  }

  function maybeTranslateTextNode(node) {
    if (!node || node.nodeType !== Node.TEXT_NODE) return;
    var raw = node.nodeValue;
    if (!raw || !raw.trim()) return;

    var withEnglishNames = restoreProductNames(raw);
    if (withEnglishNames !== raw) {
      node.nodeValue = withEnglishNames;
      raw = withEnglishNames;
    }

    var normalized = normalizeText(raw);
    var replacement = textMap[normalized];
    if (!replacement || replacement === normalized) return;

    var leadingMatch = raw.match(/^\s*/);
    var trailingMatch = raw.match(/\s*$/);
    var leading = leadingMatch ? leadingMatch[0] : "";
    var trailing = trailingMatch ? trailingMatch[0] : "";
    node.nodeValue = leading + replacement + trailing;
  }

  function translateTree(root) {
    if (!root) return;

    if (root.nodeType === Node.TEXT_NODE) {
      maybeTranslateTextNode(root);
      return;
    }

    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_FRAGMENT_NODE) {
      return;
    }

    if (root.nodeType === Node.ELEMENT_NODE && SKIP_TAGS[root.tagName]) return;

    /*
     * The filter has to run per node, not just on the root: JSON-LD and the
     * inline JSON blobs that carry variant data sit deep inside the tree, and
     * rewriting product names in there would desync structured data from the
     * page. Nodes with no space cannot hold a product name, so they bail early
     * and keep this cheap over a full collection page.
     */
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (node.nodeValue.indexOf(" ") === -1) return NodeFilter.FILTER_REJECT;
        for (var el = node.parentNode; el && el.nodeType === Node.ELEMENT_NODE; el = el.parentNode) {
          if (SKIP_TAGS[el.tagName]) return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      },
    });
    var node;
    while ((node = walker.nextNode())) {
      maybeTranslateTextNode(node);
    }
  }

  function run() {
    translateTree(document.body);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run, { once: true });
  } else {
    run();
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var mutation = mutations[i];
      if (mutation.type !== "childList") continue;
      for (var j = 0; j < mutation.addedNodes.length; j++) {
        translateTree(mutation.addedNodes[j]);
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
